/**
 * A map as an outline: every node once, in reading order, with its depth.
 *
 * The shape both text exports need. A picture of a map (SVG, PDF, PNG) is the scene; a document
 * made *from* a map — Markdown, a slide deck — is the hierarchy, read top to bottom the way the
 * outline panel reads it. Order is the order siblings were written in, not where they happen to
 * sit on the canvas: a layout moves boxes, and an export that reordered the text every time the
 * layout changed would be a different document each time.
 *
 * Hidden nodes are left out, and so is everything under them. A collapsed branch is *not* — it
 * is folded on screen, and the person exporting it still means it.
 */
import { childrenOf, toPlainText } from '@orbit-mind/domain';
export const UNTITLED = 'Untitled';
export function outlineOf(document) {
    const items = [];
    const root = document.nodes[document.map.rootNodeId];
    if (root === undefined)
        return items;
    const visit = (node, depth) => {
        if (node.hidden)
            return;
        const text = node.plainText.trim();
        items.push({
            node,
            depth,
            text: text === '' ? UNTITLED : text,
            notes: node.notes === undefined ? '' : toPlainText(node.notes).trim(),
        });
        for (const child of childrenOf(document, node.id))
            visit(child, depth + 1);
    };
    visit(root, 0);
    return items;
}
//# sourceMappingURL=outline.js.map